
import XHeader from 'vux/src/components/x-header/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
components: {
XHeader,
XDialog,
XButton,
Group
},
directives: {
TransferDom
},
props: {
title: {
type: String,
required: false
},
tipsDesc: {
type: String,
default: ''
},
tipsType: {
type: String,
default: ''
},
isRightIcon: {
type: String,
required: false
},
ImageShow: {
type: Boolean,
default: () => false
},
},
data() {
return {
visible: false,
list: []
}
},
methods: {
_initData() { // 初始化数据

}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/components/dispoint-header.vue